import React from 'react';
import CustomizedSteppers from '../common/Stepper';
import { useSelector } from 'react-redux';
import * as createConstants from '../../Constants/Create';
import * as constants from '../../Constants/Stepper';
import UploadFiles from './UploadFiles/UploadFiles';
import AddAssetDetails from './AddDetails/AddDetails';
import ReviewAndSubmitAsset from './ReviewAndSubmit/ReviewAndSubmit';
import ReviewAndSubmitAssetSuccess from './AfterSubmit/ReviewAndSubmitAssetSuccess';
import RouterBreadcrumbs from '../common/BreadCrumbs';
import { Grid, Typography } from '@material-ui/core';

const createAssetHeader = 'Create Asset';

// Loading appropriate Stepper indexes basing on the view.
const createAssetStepperSteps = (isCSVUploadViewLoaded) => {
	if (isCSVUploadViewLoaded) {
		return createConstants.CSVUploadStepperSteps;
	} else {
		return createConstants.manualEntryStepperSteps;
	}
};
// this is the primary page for the whole create asset work flow.
// all the pages (upload files, add details and review and submit) are rendered as part of this primary page
// by managing stepper component active index state
const Create = () => {
	const stepperState = useSelector((state) => state.stepper);
	// asset successfully created confirmation page. after submit.
	const successfullyCreated3dAssets = useSelector((state) => state.submittedAssets);
	const displayAfterSubmitView = successfullyCreated3dAssets.length > 0;
	// Choose steps basing on the view.
	const isCSVUploadViewLoaded = useSelector((state) => state.isCSVUploadViewLoaded);
	const steps = createAssetStepperSteps(isCSVUploadViewLoaded);
	const stepperProps = {
		steps,
	};
	// function responsible for rending content pages basing on stepper active step.
	const RenderAssetCreationStepLayout = () => {
		if (stepperState.activeStep === constants.uploadFilesStepIndex) {
			return <UploadFiles />;
		} else if (stepperState.activeStep === constants.addDetailsStepIndex) {
			return <AddAssetDetails />;
		}
		// Since the step index is incremented to 3 on create and submit of assets to check mark the last step.
		// Since stepper component only check marks the previous step.
		else if (
			stepperState.activeStep === constants.reviewAndSubmitStepIndex ||
			stepperState.activeStep === constants.reviewAndSubmitSuccessStepIndex
		) {
			if (displayAfterSubmitView) {
				return <ReviewAndSubmitAssetSuccess />;
			} else {
				return <ReviewAndSubmitAsset />;
			}
		}
	};

	return (
		<Grid container direction="column" spacing={3}>
			<Grid item>
				<Grid container>
					<Grid item sm={12} lg={2}>
						<RouterBreadcrumbs />
					</Grid>
					<Grid item sm={12} lg={10}>
						<CustomizedSteppers {...stepperProps} />
					</Grid>
				</Grid>
			</Grid>
			<Grid item>
				<Typography variant="h2">{createAssetHeader}</Typography>
			</Grid>
			<Grid item>
				<RenderAssetCreationStepLayout />
			</Grid>
		</Grid>
	);
};

export default Create;
